import PropTypes from "prop-types";
import React from "react";
import { fetchPortfolioCollectionType } from "../../utils/apis";
import { Flex, Text, Modal, useMantineTheme } from "@mantine/core";
import CustomButton from "../mantineCustomComponents/CustomButton";
import { useStylesModal } from "../../utils/mantine/useStylesModal";

const PortfolioCollectionTypeWindow = ({
  collectionID,
  portfolioCollection,
  openedModalPortfolioCollection,
  onOpenedModalPortfolioCollection,
  setPortfolioCollectionChange,
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  //css classes
  const { classes: classesModal } = useStylesModal();

  // Put Portfolio Collection enable/disable
  const handleClickPortfolioCollectionType = async () => {
    fetchPortfolioCollectionType(
      collectionID,
      portfolioCollection,
      onOpenedModalPortfolioCollection,
      setPortfolioCollectionChange,
    );
  };

  return (
    <Modal
      className={classesModal.wrap}
      opened={openedModalPortfolioCollection}
      onClose={() => onOpenedModalPortfolioCollection(false)}
      centered
      size="22rem"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      <Text
        classNames={{
          root: portfolioCollection
            ? "modal-text-portfolio-collection-enable"
            : "modal-text-portfolio-collection-disable",
        }}
      >
        {portfolioCollection
          ? "Enable this collection to be used as a portfolio collection. This allows the collection to be used for portfolio-related features and analytics."
          : "Are you sure you want to disable this collection as a portfolio collection? This will remove portfolio-specific features for this collection."}
      </Text>

      <Text className="modal-title">Proceed?</Text>

      <Flex
        justify={theme.flex.justify.center}
        gap={theme.flex.gap.large}
        mb={theme.margin.xl}
      >
        <CustomButton
          text="Yes"
          componentClasses="buttonBlack modal-button-submit"
          onClick={() => handleClickPortfolioCollectionType()}
        ></CustomButton>
        <CustomButton
          text="No"
          componentClasses="buttonWhite"
          onClick={() => onOpenedModalPortfolioCollection(false)}
        ></CustomButton>
      </Flex>
    </Modal>
  );
};

PortfolioCollectionTypeWindow.propTypes = {
  collectionID: PropTypes.string.isRequired,
  portfolioCollection: PropTypes.bool.isRequired,
  openedModalPortfolioCollection: PropTypes.bool.isRequired,
  onOpenedModalPortfolioCollection: PropTypes.func.isRequired,
  setPortfolioCollectionChange: PropTypes.func.isRequired,
};

export default PortfolioCollectionTypeWindow;
